module.exports = __webpack_public_path__ + "media/images/cheers_empty-ff66645ee694fe06c9a540dbe03ce9ed.gif";